import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {ILineItem, TableSettings} from "features/line-items";

interface Props extends Omit<ListItemsTableProps<
    ILineItem & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<ILineItem>[]
}

export function LineItemsListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}